<template>
  <div class="item-history-view">
    <table>
      <tr
        class="item-line"
        v-for="item in reviewItems"
        :key="item.id"
      >
        <td style="white-space: nowrap">
          <span>{{ item.properties.thai.value }}</span>
        </td>

        <td style="width:100%">
          <div class="item-history-line">
            <div
              class="item-history-line__entry"
              v-for="historyEntry in item.history"
              :key="historyEntry.id"
              :style="{
                'background-color': getColorForHistoryEntryScore(historyEntry.score),
                'left': getXCoordinateForDate(historyEntry.date, item.history),
              }"
            >
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<style>
.item-line:nth-of-type(odd) td {
  background: #f0f0f5;
}

.item-history-view {
  text-align: left;
  padding: 0 50px;
}

.item-history-line {
  position: relative;
  height: 30px;
}

.item-history-line__entry {
  display: inline-block;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  top: calc(50% - 5px);
  margin-left: -5px;
}
</style>

<script>
import Vue from 'vue';
import { Promised } from 'vue-promised';
Vue.component('Promised', Promised);

import { mapGetters } from 'vuex';

import * as db from '@/libs/db.js';

export default {
  name: 'ItemHistoryViewer',
  store: db.store,
  components: {
    Promised,
  },
  data: function() {
    return {
      minHistoryDate: Infinity,
      maxHistoryDate: 0,
    }
  },
  computed: {
    ...mapGetters(['reviewItems']),
  },
  methods: {
    getColorForHistoryEntryScore(score) {
      if (score == 1) {
        return 'blue';
      }
      return 'red';
    },
    getXCoordinateForDate(date, historyEntries) {
      let x = ((date - this.minHistoryDate) / (this.maxHistoryDate - this.minHistoryDate));

      x = x * 100;

      return x + '%';
    },
  },
  mounted() {
    for (let item of this.reviewItems) {
      for (let historyEntry of item.history) {
        if (historyEntry.date < this.minHistoryDate) {
          this.minHistoryDate = historyEntry.date;
        }

        if (historyEntry.date > this.maxHistoryDate) {
          this.maxHistoryDate = historyEntry.date;
        }
      }
    }
  },
}
</script>
